import { useEffect, useState } from 'react';

import { subscribe } from '../subscribe';

export function useSubscribe<DataType = unknown>(
  eventName: string,
  callback?: (data: DataType) => void,
) {
  const [data, setData] = useState<DataType>();

  useEffect(() => {
    const { unsubscribe } = subscribe<DataType>(eventName, (data) => {
      if (callback) {
        callback(data);
      } else {
        setData(data);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [eventName, callback]);

  return data;
}
